import type { ValuesType } from 'utility-types'
import type { Product } from '@scayle/storefront-core'

export const QuestionaireBadgeItem = {
  First: 'result_product_main_1',
  Second: 'result_product_main_2',
  Third: 'result_product_main_3',
  // deprecated
  BestPrice: 'best_price',
  BestSeller: 'best_seller',
  Premium: 'premium',
} as const

export type QuestionaireBadgeItem = ValuesType<typeof QuestionaireBadgeItem>

export type QuestionaireResultItem = {
  type?: QuestionaireBadgeItem
  badge: string
  product: Product
}
